import { Copy, Link2 } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { useLoad, act } from "@/lib/hooks";
import { api, fdatetime } from "@/lib/api";
import { Section, EmptyRow } from "@/components/common";

export function ClientLinks({ jobId, quoteId }) {
  const q = jobId ? `job_id=${jobId}` : `quote_id=${quoteId}`;
  const [rows, reload] = useLoad(`/portal-links?${q}`);
  const [fresh, setFresh] = useState({});
  const gen = async () => {
    const r = await act(() => api.post("/portal-links", jobId ? { kind: "proof", job_id: jobId } : { kind: "quote", quote_id: quoteId }), "Client link generated");
    if (r) { setFresh({ ...fresh, [r.id]: `${window.location.origin}${r.path}` }); reload(); }
  };
  const copy = (u) => { navigator.clipboard?.writeText(u); toast.success("Link copied"); };
  const state = (l) => (l.actioned_at ? `Used: ${(l.outcome?.action || "actioned").replace(/_/g, " ")}` : l.expires_at && new Date(l.expires_at) < new Date() ? "Expired" : l.accessed_at ? "Opened" : "Not opened");
  return (
    <Section title="Client review links" testId="client-links" action={<Button size="sm" variant="outline" data-testid="client-link-generate" onClick={gen}><Link2 className="mr-1 h-3.5 w-3.5" />Generate link</Button>}>
      <p className="px-5 pt-3 text-xs text-amber-700">Links are emailed (and sent by SMS when enabled) to the customer automatically. You can also copy a new link and share it yourself.</p>
      <div className="overflow-x-auto"><table className="po-table"><thead><tr><th>Created</th><th>For</th><th>Expires</th><th>Status</th><th /></tr></thead>
        <tbody>{rows?.length === 0 && <EmptyRow cols={5} text="No links yet." />}{rows?.map((l) => (
          <tr key={l.id} data-testid={`client-link-${l.id}`}><td>{fdatetime(l.created_at)}</td><td>{l.customer_name} {l.email ? `· ${l.email}` : ""}</td><td>{fdatetime(l.expires_at)}</td>
            <td data-testid={`client-link-status-${l.id}`}>{state(l)}</td>
            <td>{fresh[l.id] && <Button size="sm" variant="ghost" data-testid={`client-link-copy-${l.id}`} onClick={() => copy(fresh[l.id])}><Copy className="mr-1 h-3.5 w-3.5" />Copy link</Button>}</td></tr>))}</tbody></table></div>
      <p className="px-5 pb-3 text-xs text-slate-500">For security the full link is only shown right after you generate it. Generate a new one if needed.</p>
    </Section>
  );
}
